//src/mis/components/TableUsers.jsx :-
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import {
  GridRowModes,
  DataGrid,
  GridToolbarExport, 
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridCellModes,
} from '@mui/x-data-grid';
import {
  randomCreatedDate,
  randomTraderName,
  randomId,
  randomArrayItem,
} from '@mui/x-data-grid-generator';

import { useLocation, useNavigate } from "react-router-dom";
import { ReportOutlined } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useState } from "react";
import Edit from '../pages/EditRegisteredUser';
import Register from '../pages/RegisterUser';

import { TextField, FormControl, InputLabel, Select, MenuItem, IconButton } from '@mui/material';
import { SaveAlt as SaveAltIcon, Refresh, Search } from '@mui/icons-material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { InputAdornment } from "@mui/material";

import env from "react-dotenv";

const initialRows = [
  
];

function EditToolbar(props) {
  const { setRows, setRowModesModel, departments } = props;
  const navigate = useNavigate();
  const { selectedCellParams, cellMode, cellModesModel, setCellModesModel  } = props;
  const user = useSelector((state) => state.user);
  const [isAdmin, setIsAdmin] = useState(user?.role === 'Super Admin' ? true : false);
  const [isAllowed, setIsAllowed] = useState(false);

  const location = useLocation();
  React.useEffect( () => {
    if(location.key === undefined || location.key === null || location.key === 'default'){
      navigate("/");   
    }
  }, [ location ] );

  const handleSaveOrEdit = () => {
    if (!selectedCellParams) {
      return;
    }
    const { id, field } = selectedCellParams;
    
    if (cellMode === 'edit') {      
        navigate(`../edit/${id}`, { replace: true })
    } else {
        navigate(`../edit/${id}`, { replace: true })
    }
  };

  const handleDelete = async () => {
    
    if (!selectedCellParams) {
        return;
      }
      const { id, field, dataId } = selectedCellParams;
      const rIndex = dataId;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_MISBACKEND_URL}/deleteUserRecord/${rIndex}`,
        {
          method: "DELETE",
        }
      );
      navigate(0);
      navigate("../maintenanceHome/2");
     
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    if (!selectedCellParams) {
      return;
    }
    const { id, field } = selectedCellParams;
    setCellModesModel({
      ...cellModesModel,
      [id]: {
        ...cellModesModel[id],
        [field]: { mode: GridCellModes.View, ignoreModifications: true },
      },
    });
  };

  const handleMouseDown = (event) => {
    // Keep the focus in the cell
    event.preventDefault();
  };

  const handleClick = () => {
    // const id = randomId();
    // setRows((oldRows) => [...oldRows, { id, name: '', age: '', isNew: true }]);
    // setRowModesModel((oldModel) => ({
    //   ...oldModel,
    //   [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
    // }));
  };

  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);

  return (
   
    <GridToolbarContainer>
        
        <div>
             <Button onClick={()=>setOpen(true)}>Add User</Button>
             <Register open={open} onClose={() => setOpen(false)} departments={departments} />
         </div>
         <div>
          <Button color="primary" startIcon={<EditIcon />}
          onClick={()=>{setOpenEdit(true)}}
          onMouseDown={handleMouseDown}
          disabled={!selectedCellParams}
          >
          Edit
          </Button> 
          <Edit onSelected={selectedCellParams} open={openEdit} onClose={() => setOpenEdit(false)} departments={departments} /> 
          </div>
            
        
        {isAdmin && false && (  <Button color="primary" startIcon={<DeleteIcon />}
          onClick={handleDelete}
          onMouseDown={handleMouseDown}
          disabled={!selectedCellParams}
        
        >
          {cellMode === 'edit' ? 'Delete' : 'Delete'}
        </Button>
        )}
        {/* <GridToolbarExport/> */}
    
    </GridToolbarContainer>
  );
}
const FullFeaturedCrudGrid = () => {

  const [selectedCellParams, setSelectedCellParams] = React.useState(null);
  const [cellModesModel, setCellModesModel] = React.useState({});
  const user = useSelector((state) => state.user);
  const [isAdmin, setIsAdmin] = useState(user?.role === 'Super Admin' ? true : false);
  const [departments, setDepartments] = useState([]);
  
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser , setSelectedUser ] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [uniqueUsers, setUniqueUsers] = useState([]);
  const [uniqueDepartments, setUniqueDepartments] = useState([]);
  const [uniqueRoles, setUniqueRoles] = useState([]);
  const [showFilters, setShowFilters] = useState(false); // State to control filter visibility
  
  const handleCellFocus = React.useCallback((event) => {
    const row = event.currentTarget.parentElement;
    const dataId = row.dataset.id;
    const id = row.dataset.rowindex;
    const field = event.currentTarget.dataset.field;
    setSelectedCellParams({ id, field , dataId });
 
  }, []);

  const cellMode = React.useMemo(() => {
    if (!selectedCellParams) {
      return 'view';
    }
    const { id, field } = selectedCellParams;
    return cellModesModel[id]?.[field]?.mode || 'view';
  }, [cellModesModel, selectedCellParams]);

  const handleCellKeyDown = React.useCallback(
    (params, event) => {
      if (cellMode === 'edit') {
        // Prevents calling event.preventDefault() if Tab is pressed on a cell in edit mode
        event.defaultMuiPrevented = true;
      }
    },
    [cellMode],
  );

  const handleCellEditStop = React.useCallback((params, event) => {
    event.defaultMuiPrevented = true;
  }, []);


  const [rows, setRows] = React.useState(initialRows);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const navigate = useNavigate();

  const getRowsFromDB = async () => {
    try 
    {
      const maintenanceResponse = await fetch(`${process.env.REACT_APP_USERMGMT_URL}/notes`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
     
      });
      const records = await maintenanceResponse.json();
      // console.log(records)
      setRows(Object.keys(records).map((key) => records[key]));
      setUniqueUsers([...new Set(records.map(record => record.full_name))]);
      setUniqueRoles([...new Set(records.map(record => record.user_role))]);

    } catch (error) {
      
      console.log(error);
    }
  };

  const getDepartmentsFromDB = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_PJCBACKEND_URL}/api/department`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();
      setDepartments(data); // Assuming the response is an array of departments
      setUniqueDepartments([...new Set(data.map(record => record.dept_name))]);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  React.useEffect(() => {
    getRowsFromDB();
    getDepartmentsFromDB(); // Fetch departments
  }, []);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const onRowsSelectionHandler = (ids) => {
    
    navigate(`../edit/${ids}`, { replace: true })
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const clearFilters = () => {
    setSearchTerm("");
    setSelectedUser ("");
    setSelectedDepartment([]);
    setSelectedRole("");
  };
  const filteredRows = rows.filter(row => {
    const matchesSearch = Object.values(row).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );
    const matchesUser  = !selectedUser  || row.full_name === selectedUser ;
    const matchesDepartment = !selectedDepartment.length || selectedDepartment.includes(row.department);
    const matchesRole = !selectedRole || row.user_role === selectedRole;
    return matchesSearch && matchesUser  && matchesDepartment && matchesRole;
  });

  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Users');

    // Add title row
    const titleRow = worksheet.addRow(['ARYAN EXPORTERS PVT. LTD.']);
    worksheet.mergeCells(`A1:F1`); // Adjust the range based on the number of columns
    titleRow.alignment = { horizontal: 'center', vertical: 'middle' };
    const mergedTitleCell = worksheet.getCell('A1');
    mergedTitleCell.font = { bold: true, size: 14 };

    // Add summary row
    const summaryRow = worksheet.addRow([`Summary Of Users`]);
    worksheet.mergeCells(`A2:F2`); // Adjust the range based on the number of columns
    summaryRow.alignment = { horizontal: 'center', vertical: 'middle' };
    const mergedSummaryCell = worksheet.getCell('A2');
    mergedSummaryCell.font = { bold: true, size: 12 };

    // Add header row
    const headerRow = worksheet.addRow(['ID', 'Full Name', 'Mobile', 'Role', 'Email', 'Department']);
    headerRow.font = { bold: true };

    // Add data rows
    filteredRows.forEach(row => {
        worksheet.addRow([
            row.id,
            row.full_name,
            row.mobile,
            row.user_role,
            row.email,
            row.department,
        ]);
    });

    // Set specific column widths
    worksheet.getColumn(1).width = 10;  // ID
    worksheet.getColumn(2).width = 20;  // Full Name
    worksheet.getColumn(3).width = 12;  // Mobile
    worksheet.getColumn(4).width = 15;  // Role
    worksheet.getColumn(5).width = 30;  // Email
    worksheet.getColumn(6).width = 120;  // Department

    // Apply borders to all cells
    worksheet.eachRow((row) => {
        row.eachCell((cell) => {
            cell.border = {
                top: { style: 'thin' },
                bottom: { style: 'thin' },
                left: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
    });

    // Save the workbook
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(blob, 'Users.xlsx');
};

  const columns = [
    {
      field: 'id',
      headerName: 'id',     
      hideable: true,
      width: 80,
    },    
    {
      field: 'full_name',
      headerName: 'Full Name',    
      width: 150,    
    },
    
    { field: 'mobile', headerName: 'Mobile', width: 100},
    {
      field: 'user_role',
      headerName: 'Role',
      width: 140,
      
    },
    { field: 'email', headerName: 'Email', width: 180},
    { field: 'department', headerName: 'Department', width: 650},     
  ];

  return (
    <Box
    sx={{
      height: 480,
      width: '95%',
      marginLeft:"180px",
      paddingRight:"90px",
      marginTop: "0px"
    }}
    > 

    <Box sx={{ marginBottom: "15px", display: "flex", gap: "10px", alignItems: "center" }}>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          sx={{
            backgroundColor: '#ffffff',
            width: '1200px',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#00308F',
              },
              '&:hover fieldset': {
                borderColor: '#00207E',
              },
            },
          }}
        />

        <Button onClick={() => setShowFilters(!showFilters)} startIcon={<FilterListIcon />}>
          Filter
        </Button>
        
        <Button onClick={handleExport} startIcon={<SaveAltIcon />}>
          Export
        </Button>
        <IconButton
          onClick={() => window.location.reload()} // Refresh the page
          color="primary"
          sx={{
            backgroundColor: '#ffffff',
            '&:hover': {
              backgroundColor: '#f0f0f0',
            },
          }}
        >
          <Refresh />
        </IconButton>
      </Box>

      {/* Conditional rendering of additional filter fields */}
      {showFilters && (
        <Box sx={{ marginBottom: "10px", display: "flex", gap: "10px", alignItems: "center" }}>
          <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>
            <InputLabel>User</InputLabel>
            <Select
              value={selectedUser }
              onChange={(e) => setSelectedUser (e.target.value)}
              label="User "
            >
              <MenuItem key='' value=''>No selection</MenuItem>
              {uniqueUsers.map((user) => (
                <MenuItem key={user} value={user}>
                  {user}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Department</InputLabel>
            <Select
              multiple
              value={selectedDepartment}
              onChange={(e) => setSelectedDepartment(e.target.value)}
              label="Department"
              renderValue={(selected) => selected.join(', ')}
            >
              <MenuItem key='' value=''>No selection</MenuItem>
              {uniqueDepartments.map((department) => (
                <MenuItem key={department} value={department}>
                  {department}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Role</InputLabel>
            <Select
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
              label="Role"
            >
              <MenuItem key='' value=''>No selection</MenuItem>
              {uniqueRoles.map((role) => (
                <MenuItem key={role} value={role}>
                  {role}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button onClick={clearFilters}>
            Clear Filters
          </Button>
        </Box>
      )}

      <DataGrid
        // rows={rows.slice(0).sort().reverse()}
        rows={filteredRows}
        initialState={{
        
          columns: {
            
            columnVisibilityModel: {
              id: false,
            },
          },
        }}
        columns={columns}
        checkboxSelection 
        disableMultipleRowSelection
        sx={{
            boxShadow: 1,
            border: 1,
            borderColor: 'primary.light',
            typography: 'subtitle2',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            '.MuiDataGrid-columnHeaderTitle': { 
                font: 'light important',
                overflow: 'visible !important'
             }
          }}
        
        onCellKeyDown={handleCellKeyDown}
        cellModesModel={cellModesModel}
        onCellEditStop={handleCellEditStop}
        onCellModesModelChange={(model) => setCellModesModel(model)}
        slots={{
            toolbar: EditToolbar           
          }}
        slotProps={{
            toolbar: {
              cellMode,
              selectedCellParams,
              setSelectedCellParams,
              cellModesModel,
              setCellModesModel,
              departments, // Pass departments to the toolbar
            },
            cell: {
              onFocus: handleCellFocus,
            },
        }}
      />
    </Box>
  );
}
export default FullFeaturedCrudGrid;